import fetch from 'lib/fetch'
import { parseErrors } from 'lib/api-utils'
import { REGISTRY_ROLES } from 'registry/constants'
import {
  apiV3CreateRegistryPath,
  apiV3TemplatesClonePath,
  apiV3TemplatesPath,
} from 'lib/urls'

export const cloneTemplate = (templateId, registryId) =>
  fetch(apiV3TemplatesClonePath(templateId), {
    body: JSON.stringify({
      registry_id: registryId,
    }),
    method: 'POST',
  })
    .then((resp) => resp.data)
    .catch((resp) => Promise.reject(parseErrors(resp)))

export const createRegistry = (data) =>
  fetch(apiV3CreateRegistryPath, {
    body: JSON.stringify(data),
    method: 'POST',
  }).catch((resp) => Promise.reject(parseErrors(resp)))

export const fetchTemplates = (id) =>
  fetch(apiV3TemplatesPath(id), {
    method: 'GET',
  })
    .then((resp) => resp.data)
    .catch((resp) => Promise.reject(parseErrors(resp)))
